export const ACCESS_RIGHTS_STORE_KEY = 'access-rights';
